// Os ids são gravados no item da habilitação (user_event_items.type); não reaproveite valores.
const judicialRecovery = [
    { id: 1, name: 'Classe I - Trabalhista' },
    { id: 2, name: 'Classe II - Garantia Real' },
    { id: 3, name: 'Classe III - Quirografários' },
    { id: 4, name: 'Classe IV - ME/EPP' },
    { id: 5, name: 'Extraconcursal/Pago' }
];

// Na falência a ordem segue o art. 83 da Lei 11.101/2005, sem a numeração de classes da RJ.
const bankruptcy = [
    { id: 1, name: 'Trabalhista' },
    { id: 2, name: 'Garantia Real' },
    { id: 6, name: 'Tributário' },
    { id: 3, name: 'Quirografários' },
    { id: 4, name: 'ME/EPP' },
    { id: 5, name: 'Extraconcursais' }
];

const BANKRUPTCY_TYPE = 2;

export const getCreditorTypes = (clientType) =>
    clientType === BANKRUPTCY_TYPE ? [...bankruptcy] : [...judicialRecovery];

export default [...judicialRecovery, bankruptcy.find((item) => item.id === 6)];
